// Lodash
import _reduce from 'lodash/reduce'
import _get from 'lodash/get'

// Constants
import { Constants } from '@sukiai/components'

const { NOTE_STATUS } = Constants

const getCompletedNotesCount = (notes) =>
  _reduce(
    notes,
    (completedNotesCount, note) => {
      const status = _get(note, 'metadata.status')
      if (status === NOTE_STATUS.SUBMITTED_TO_EMR) {
        completedNotesCount += 1
      }
      return completedNotesCount
    },
    0
  )

export { getCompletedNotesCount }
